module.exports = __webpack_public_path__ + "img/playson.99a4d9f0.svg";